import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { MobilePersonOverview, MobilePersonNavigation } from "@/components/MobileNavigationLandingPage";
import { useNavigate, Path } from "@/router";
import { usePersonErrorHandling } from "./_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "./_components/PersonNotFoundErrorBoundary";
import { useReturnTo } from "@/hooks/useSearchParams";

export default function MobilePersonLandingPage() {
  const navigate = useNavigate();
  const returnTo = useReturnTo();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  // Early return for error cases
  if (shouldRenderError) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <Breadcrumb
          compactOnly
          compactTitle="Manage Person"
          backLink={{ to: "/people" }}
          onBackClick={() => navigate((returnTo || "/people") as Path)}
        />
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb
        compactOnly
        compactTitle="Manage Person"
        backLink={{ to: "/people" }}
        onBackClick={() => navigate((returnTo || "/people") as Path)}
      />
      <MobilePersonOverview pgaId={pgaId!} />
      <MobilePersonNavigation pgaId={pgaId!} />
    </AppLayout>
  );
}
